const IGNORE_AUTOFILL = {
  autoComplete: "off",
  "data-1p-ignore": "true",
  // 1Password
  "data-lpignore": "true",
  // LastPass
  "data-bwignore": "true",
  // Bitwarden
  "data-form-type": "other"
  // Dashlane (also a 1Password hint)
};
export default IGNORE_AUTOFILL;
